import { useRef } from 'react'
import styled from '@emotion/styled'
import AlertMessage from './AlertMessage'
import { CartItemList } from '../Cart'
import { CartType } from '../Cart/Cart'
import { OrderItem, OrderItemWithVatPrices } from 'shop/types/cart'

interface Props {
  validOrderItems: OrderItem[]
  invalidOrderItems: OrderItemWithVatPrices[]
  unavailableOrderItems: OrderItem[]
  onQuantityChange: (
    orderItem: OrderItem,
    delta: number,
    proceedWithNewOrderItems?: boolean
  ) => Promise<void>
}

const CartModalItemList = ({
  validOrderItems,
  invalidOrderItems,
  unavailableOrderItems,
  onQuantityChange
}: Props) => {
  const itemsContainerRef = useRef<HTMLDivElement>(null)

  return (
    <>
      <Items ref={itemsContainerRef}>
        {!!validOrderItems.length && (
          <CartItemList
            items={validOrderItems}
            type={CartType.Cart}
            onQuantityChange={onQuantityChange}
          />
        )}
      </Items>

      {!!invalidOrderItems.length && (
        <AlertMessage
          heading='Pricing of these item(s) have changed.'
          subheading='Please remove and re-add these item(s) to your cart.'
          type='error'
        />
      )}
      <Items>
        {!!invalidOrderItems.length && (
          <CartItemList
            items={invalidOrderItems}
            type={CartType.Cart}
            onQuantityChange={onQuantityChange}
          />
        )}
      </Items>

      {!!unavailableOrderItems.length && (
        <AlertMessage
          heading='These item(s) are not available in this store'
          subheading='Please remove these item(s) from your cart.'
          type='error'
        />
      )}
      <Items>
        {!!unavailableOrderItems.length && (
          <CartItemList
            items={unavailableOrderItems}
            type={CartType.Cart}
            onQuantityChange={onQuantityChange}
          />
        )}
      </Items>
    </>
  )
}

const Items = styled.div(() => ({
  marginBottom: '16px'
}))

export default CartModalItemList
